import React from 'react';
import { Toggle } from 'ui';
import {
  getListFlowPricing,
  toggleAcceptsOffers,
} from '~/store/listFlow/slices/pricing';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowAcceptOffersRow: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const pricing = useAppSelector(getListFlowPricing);

  if (pricing.isAuction) {
    return null;
  }

  return (
    <label className="mt-4 flex justify-between">
      <span className="text-sm font-semibold">Accept Offers</span>
      <Toggle
        onChange={enabled => dispatch(toggleAcceptsOffers({ enabled }))}
        value={pricing.acceptOffers || false}
      />
    </label>
  );
};

export default ListFlowAcceptOffersRow;
